// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from '../DirectMessageBase';
import { Message } from '../Message';
export class TradingWebhookListResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADING_WEBHOOK_LIST_RESPONSE);
        this.webhooks = [];
    }
}
export class TradingWebhook {
    constructor(id, name, createdAt, expireAt) {
        this.id = id;
        this.name = name;
        this.createdAt = createdAt;
        this.expireAt = expireAt;
    }
}
